/**
 * Prefix used for feature flag overrides in URL parameters.
 */
export const FEATURE_FLAG_URL_PARAM_PREFIX = 'ff.';

/**
 *
 * Parses the URL for feature flag overrides
 * ?ff.<flagName>=<flagValue>&ff.<flagName2>=<flagValue2>
 */
export function getURLParamsFeatureFlagOverrides(search: string) {
  const urlParams = new URLSearchParams(search);
  const overrides: Record<string, string> = {};
  for (const [key, value] of urlParams.entries()) {
    if (key.startsWith(FEATURE_FLAG_URL_PARAM_PREFIX)) {
      const flagName = key.slice(3); // remove the 'ff.' prefix
      try {
        // Try to parse the value as JSON
        overrides[flagName] = JSON.parse(value);
      } catch (_e) {
        // If it fails, use the raw value
        overrides[flagName] = value;
      }
    }
  }
  return overrides;
}

/**
 * Overrides real flag state with states set in feature-flags.json which are then injected via an environment variable
 * (only used in local dev).
 */
export function getFeatureFlagOverridesFromEnv() {
  try {
    if (process.env.NODE_ENV !== 'development') {
      return {};
    }
    if (process.env.SKIP_FEATURE_FLAGS_OVERRIDES === 'true') {
      return {};
    }

    const flagStr = process.env.FEATURE_FLAG_OVERRIDES;
    return flagStr === undefined ? {} : flagStr;
  } catch (e) {
    // Check if feature flag overrides are valid JSON
    console.error('Error parsing feature flag override values', e);
    return {};
  }
}
